import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//引入样式重置
import "reset-css";
//引入element-ui
//引入MD5加密算法
import md5 from "js-md5"
//引入Echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.prototype.$md5 = md5;
Vue.mixin({
    methods:{
        formatDate(val,type){ //格式化时间戳 type = yyyy-MM-dd hh:mm:ss
            if(!(val instanceof Date)){
                if(isNaN(val)){
                    val = val.replace(/-/g,"/")
                }else{
                    val = parseInt(val)
                }
            }
            let d = new Date(val);
            let year = d.getFullYear();
            let month = d.getMonth()+1<10?"0"+(d.getMonth()+1):d.getMonth()+1;
            let date = d.getDate()<10?"0"+d.getDate():d.getDate();
            let hours = d.getHours()<10?"0"+d.getHours():d.getHours();
            let minutes = d.getMinutes()<10?"0"+d.getMinutes():d.getMinutes();
            let seconds = d.getSeconds()<10?"0"+d.getSeconds():d.getSeconds();
            return String(type).replace(/y+/,year).replace(/M+/,month).replace(/d+/,date).replace(/h+/,hours).replace(/m+/,minutes).replace(/s+/,seconds)
        }
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
